<template>
  <div class="section-width">
    <b-row>
      <b-col cols="2" class="p-0">
        <b-img :src="require('/static/images/main/soldador.png')" width="230" class="side-edge" id="img-side"/>
      </b-col>
      <b-col cols="5" class="text-center">
        <h1 class="carter-one-regular">Com problemas na sua obra ?</h1>
        <h4>Nós temos a solução que você precisa !</h4>
        <h4>Somos especializados na prestação de serviços técnicos de qualidade nas mais diversas áreas.</h4>
      </b-col>
      <b-col cols="5">
        <iframe
          width="600"
          height="337"
          src="https://www.youtube.com/embed/jADRv4NR-ko?si=yXPWnNySF73Y1UBj"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen
        ></iframe>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "HomeFirstSection",
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Carter+One&display=swap");

.carter-one-regular {
  font-family: "Carter One", system-ui;
  font-weight: 400;
  font-style: normal;
}

.section-width {
  width: 80%;
  padding-top: 5%;
  padding-bottom: 6%;
}

.side-edge {
  position: relative;
  left: 0%;
  
}

@keyframes grinder {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(96%);
    left: -4%;
  }
}
</style>
